import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { materialGoodsReceiptBusiness } from "api/bussiness/material/material-goods-receipt";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddMaterialGoodsReceipt } from "mobx-stores/_models/material-inventory/material-goods-receipt/material-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddMaterialGoodsReceiptSchema } from "./schema";

export const AddMaterialGoodsReceipt = observer(() => {
  const {
    materialInventoryManagement: {
      materialGoodsReceiptStore: { openNew, getMaterialGoodsReceipt, setProp },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<IAddMaterialGoodsReceipt>(getAddMaterialGoodsReceiptSchema(), {
    receiptDate: dateTimeToUTCString(dayjs()),
    items: [
      {
        materialId: "",
        amount: 0,
        wareHouse: "",
        brand: "",
        supplier: "",
        document: "",
        note: "",
        origin: "",
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddMaterialGoodsReceipt) => {
      try {
        await materialGoodsReceiptBusiness.add(data);
        await getMaterialGoodsReceipt();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getMaterialGoodsReceipt, setProp]
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm nhập kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
